import { PrintersPage } from "../../pages/printers";

export const routePrinters = "/printers";

export const printersRoutes = [
	{
		path: routePrinters,
		element: <PrintersPage />,
	},
];
